module.exports = __webpack_public_path__ + "img/book-of-dead.a1d8ab03.png";